import React from 'react';
import validator from 'validator';
import * as EmailValidator from 'email-validator/index';
import InputText from './InputText';
import InputDate from './InputDate';
import {DateUtils} from "react-day-picker";
import {popupWindow} from "./utils/Popup";
import {FormattedMessage} from "react-intl";
import PRCardLightbox from './PRCardLightbox';
import GreenCardLightbox from './GreenCardLightbox';

class Reminder extends React.Component {
    constructor(props) {
        super(props);
        let search = window.location.search;
        let params = new URLSearchParams(search);

        this.state = {
            togglePRCardLightbox: false,
            toggleGreenCardLightbox: false,
            firstName: '',
            lastName: '',
            emailAddress: params.get('emailId') ? params.get('emailId') : '',
            gcExpMonth: '',
            gcExpDay: '',
            gcExpYear: '',
            gcExpiryDate: '',
            eventDate: '',
            residenceSinceDay: '',
            residenceSinceMonth: '',
            residenceSinceYear: '',
            residenceSinceDate: '',
            iagree: '',
            isFirstNameError: false,
            isLastNameError: false,
            isEmailAddressError: false,
            isGCExpirationDateError: false,
            isResidenceSinceDateError: false,
            isResidenceSinceDateCompareError: false,
            isIagreeError: false,
            firstNameErrorMessage: false,
            lastNameErrorMessage: false,
            emailAddressErrorMessage: false,
            gcExpirationDateErrorMessage: false,
            residenceSinceDateErrorMessage: false,
            residenceSinceDateCompareErrorMessage: false,
            isValidResidenceSinceDate: false,
            iagreeErrorMessage: false,
            submitInProgress: false,
            isCompleteErrorStatus: false,
            existingCustomer: !!params.get('emailId')
        }

        this.submitClick = this.submitClick.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    static getFormattedGCExpYear(gcExpYear) {
        const currentYear = new Date().getFullYear();
        if (gcExpYear >= 89 && gcExpYear <= 99) {
            // Green Card Expired in the Previous Century (19XX)
            return (currentYear - 100).toString().substring(0, 2) + gcExpYear;
        } else if (gcExpYear >= 0 && gcExpYear <= (currentYear + 10).toString().substring(2)) {
            // Green Card Expired or will Expire in the Current Century (20XX)
            return currentYear.toString().substring(0, 2) + gcExpYear;
        } else {
            return gcExpYear;
        }
    }

    static getFormattedResidenceSinceYear(residenceSinceYear) {
        const currentYear = new Date().getFullYear();
        if (residenceSinceYear >= 0 && residenceSinceYear <= (currentYear).toString().substring(2)) {
            // Green Card was Issued in the Current Century (20XX)
            return currentYear.toString().substring(0, 2) + residenceSinceYear;
        } else {
            // Green Card was Issued in the Previous Century (19XX)
            return (currentYear - 100).toString().substring(0, 2) + residenceSinceYear;
        }
    }

    static daysInMonths(month, year) {
        // Month is indexed as 0-11
        switch (month - 1) {
            case 1:
                return (year % 4 === 0 && year % 100) || year % 400 === 0 ? 29 : 28;
            case 3:
            case 5:
            case 8:
            case 10:
                return 30;
            default:
                return 31;
        }
    }

    static isValidDate(month, day, year) {
        // Month is indexed as 0-11
        return month - 1 >= 0 && month - 1 < 12 && day > 0 && day <= Reminder.daysInMonths(month, year);
    }

    validateFirstName(firstName) {
        if (validator.isEmpty(firstName)) {
            this.setState({isFirstNameError: true, firstNameErrorMessage: "error.validation.required.text"});
        } else {
            let firstNameRegExp = new RegExp("^[a-zA-Z\\s|\\,|\\.|\\-|\\']+$");
            if (firstNameRegExp.test(firstName)) {
                this.setState({isFirstNameError: false, firstNameErrorMessage: ""});
            } else {
                this.setState({isFirstNameError: true, firstNameErrorMessage: "error.validation.invalid.character"});
            }
        }
    }

    validateLastName(lastName) {
        if (validator.isEmpty(lastName)) {
            this.setState({isLastNameError: true, lastNameErrorMessage: "error.validation.required.text"});
        } else {
            let lastNameRegExp = new RegExp("^[a-zA-Z\\s|\\,|\\.|\\-|\\']+$");
            if (lastNameRegExp.test(lastName)) {
                this.setState({isLastNameError: false, lastNameErrorMessage: ""});
            } else {
                this.setState({isLastNameError: true, lastNameErrorMessage: "error.validation.invalid.character"});
            }
        }
    }

    validateEmailAddress(emailAddress) {
        if (validator.isEmpty(emailAddress)) {
            this.setState({isEmailAddressError: true, emailAddressErrorMessage: "error.validation.required.text"});
        } else {
            if (EmailValidator.validate(emailAddress)) {
                this.setState({isEmailAddressError: false, emailAddressErrorMessage: ""});
            } else {
                this.setState({
                    isEmailAddressError: true,
                    emailAddressErrorMessage: "error.validation.invalid.character"
                });
            }
        }
    }

    validateGCExpirationDate(gcExpMonth, gcExpDay, gcExpYear) {
        if (validator.isEmpty(gcExpMonth) || validator.isEmpty(gcExpDay) || validator.isEmpty(gcExpYear)) {
            this.setState({
                isGCExpirationDateError: true, gcExpirationDateErrorMessage: "error.validation.required.date"
            });
        } else {
            if (validator.isNumeric(gcExpMonth) && validator.isNumeric(gcExpDay) && validator.isNumeric(gcExpYear) &&
                gcExpMonth.length === 2 && gcExpDay.length === 2 && gcExpYear.length === 2) {

                gcExpYear = Reminder.getFormattedGCExpYear(gcExpYear);

                // Month is indexed as 0-11 in the `DateUtils`
                if (gcExpYear.length === 4 && Reminder.isValidDate(gcExpMonth, gcExpDay, gcExpYear)) {
                    this.setState({isGCExpirationDateError: false, gcExpirationDateErrorMessage: ""});
                    this.setState({gcExpiryDate: Reminder.getFormattedGCExpYear(this.state.gcExpYear) + "-" + this.state.gcExpMonth + "-" + this.state.gcExpDay});
                    this.setState({eventDate: Reminder.getFormattedGCExpYear(this.state.gcExpYear) + "-" + this.state.gcExpMonth + "-" + this.state.gcExpDay});
                } else {
                    this.setState({
                        isGCExpirationDateError: true,
                        gcExpirationDateErrorMessage: "error.validation.invalid.date"
                    });
                }

            } else {
                this.setState({
                    isGCExpirationDateError: true,
                    gcExpirationDateErrorMessage: "error.validation.invalid.date"
                });
            }
        }
    }

    validateResidenceSinceDate(residenceSinceMonth, residenceSinceDay, residenceSinceYear) {
        if (validator.isEmpty(residenceSinceMonth) || validator.isEmpty(residenceSinceDay) || validator.isEmpty(residenceSinceYear)) {
            this.setState({
                isResidenceSinceDateError: true,
                residenceSinceDateErrorMessage: "error.validation.required.date"
            });
        } else {
            if (validator.isNumeric(residenceSinceMonth) && validator.isNumeric(residenceSinceDay) && validator.isNumeric(residenceSinceYear) &&
                residenceSinceMonth.length === 2 && residenceSinceDay.length === 2 && residenceSinceYear.length === 2) {

                residenceSinceYear = Reminder.getFormattedResidenceSinceYear(residenceSinceYear);

                // Month is indexed as 0-11 in the `DateUtils`
                if (Reminder.isValidDate(residenceSinceMonth, residenceSinceDay, residenceSinceYear) && !DateUtils.isFutureDay(new Date(residenceSinceYear, residenceSinceMonth - 1, residenceSinceDay))) {
                    this.setState({residenceSinceDate: Reminder.getFormattedResidenceSinceYear(this.state.residenceSinceYear) + "-" + this.state.residenceSinceMonth + "-" + this.state.residenceSinceDay});
                    this.setState({isResidenceSinceDateError: false, residenceSinceDateErrorMessage: ""});
                } else {
                    this.setState({
                        isResidenceSinceDateError: true,
                        residenceSinceDateErrorMessage: "error.validation.invalid.date"
                    });
                }
            } else {
                this.setState({
                    isResidenceSinceDateError: true,
                    residenceSinceDateErrorMessage: "error.validation.invalid.date"
                });
            }
        }
    }

    compareResidenceSinceDateAndGcExpiryDate(gcExpMonth, gcExpDay, gcExpYear, residenceSinceMonth, residenceSinceDay, residenceSinceYear) {
        if (residenceSinceYear !== null
            && residenceSinceYear !== ''
            && residenceSinceMonth !== null
            && residenceSinceMonth !== ''
            && residenceSinceDay !== null
            && residenceSinceDay !== ''
            && gcExpYear !== null
            && gcExpYear !== ''
            && gcExpMonth !== null
            && gcExpMonth !== ''
            && gcExpDay !== null
            && gcExpDay !== ''
            && DateUtils.isDayBefore(new Date(Reminder.getFormattedResidenceSinceYear(residenceSinceYear), residenceSinceMonth - 1, residenceSinceDay),
                new Date(Reminder.getFormattedGCExpYear(gcExpYear), gcExpMonth - 1, gcExpDay))) {

            this.setState({isResidenceSinceDateCompareError: false, residenceSinceDateCompareErrorMessage: ""});
        } else {
            this.setState({
                isResidenceSinceDateCompareError: true,
                residenceSinceDateCompareErrorMessage: "error.validation.invalid.residenceSinceDate"
            });
        }
    }

    validateIagreeCheckbox(iagree) {
        if (iagree) {
            this.setState({isIagreeError: false, iagreeErrorMessage: ""});
        } else {
            this.setState({isIagreeError: true, iagreeErrorMessage: "error.validation.required.checkbox"});
        }
    }

    handleChange = (event) => {
        switch (event.target.id) {
            case 'quiz.gcReminder.name.first':
                this.setState({firstName: event.target.value});
                break;
            case 'quiz.gcReminder.name.last':
                this.setState({lastName: event.target.value});
                break;
            case 'quiz.gcReminder.emailAddress':
                this.setState({emailAddress: event.target.value});
                break;
            case 'quiz.gcReminder.gcExpiryDate.day':
                this.setState({gcExpDay: event.target.value});
                break;
            case 'quiz.gcReminder.gcExpiryDate.month':
                this.setState({gcExpMonth: event.target.value});
                break;
            case 'quiz.gcReminder.gcExpiryDate.year':
                this.setState({gcExpYear: event.target.value});
                break;
            case 'quiz.gcReminder.residenceSinceDate.month':
                this.setState({residenceSinceMonth: event.target.value});
                break;
            case 'quiz.gcReminder.residenceSinceDate.day':
                this.setState({residenceSinceDay: event.target.value});
                break;
            case 'quiz.gcReminder.residenceSinceDate.year':
                this.setState({residenceSinceYear: event.target.value});
                break;
            case 'iagree':
                this.setState({iagree: event.target.checked});
                break;
            default:
                return;
        }
    }

    submitClick = (event) => {
        if (this.state.submitInProgress) {
            event.preventDefault();
        }

        if (!this.state.existingCustomer) {
            this.validateFirstName(this.state.firstName);
            this.validateLastName(this.state.lastName);
            this.validateEmailAddress(this.state.emailAddress);
        }

        this.validateGCExpirationDate(this.state.gcExpMonth, this.state.gcExpDay, this.state.gcExpYear);
        this.validateResidenceSinceDate(this.state.residenceSinceMonth, this.state.residenceSinceDay, this.state.residenceSinceYear);
        this.compareResidenceSinceDateAndGcExpiryDate(this.state.gcExpMonth, this.state.gcExpDay, this.state.gcExpYear,
            this.state.residenceSinceMonth, this.state.residenceSinceDay, this.state.residenceSinceYear);
        this.validateIagreeCheckbox(this.state.iagree);
    }

    handleClick = (event) => {
        switch (event.target.id) {
            case 'prCard':
            case 'prCardLarge':
            case 'prCardLightboxClose':
                this.setState(prevState => ({
                    togglePRCardLightbox: !prevState.togglePRCardLightbox
                }));
                break;
            case 'greenCard':
            case 'greenCardLarge':
            case 'greenCardLightboxClose':
                this.setState(prevState => ({
                    toggleGreenCardLightbox: !prevState.toggleGreenCardLightbox
                }));
                break;
            default:
                return;
        }
    }

    handleSubmit = (event) => {
        if (this.state.isFirstNameError ||
            this.state.isLastNameError ||
            this.state.isEmailAddressError ||
            this.state.isGCExpirationDateError ||
            this.state.isResidenceSinceDateError ||
            this.state.isResidenceSinceDateCompareError ||
            this.state.isIagreeError) {

            this.setState({isCompleteErrorStatus: true});
            event.preventDefault();

        } else {
            this.setState({isCompleteErrorStatus: false, submitInProgress: true});
        }

        if (this.state.isFirstNameError) {
            document.getElementById("quiz.gcReminder.name.first").focus();
        } else if (this.state.isLastNameError) {
            document.getElementById("quiz.gcReminder.name.last").focus();
        } else if (this.state.isEmailAddressError) {
            document.getElementById("quiz.gcReminder.emailAddress").focus();
        } else if (this.state.isGCExpirationDateError) {
            if (validator.isEmpty(this.state.gcExpMonth)) {
                document.getElementById("quiz.gcReminder.gcExpiryDate.month").focus();
            } else if (validator.isEmpty(this.state.gcExpDay)) {
                document.getElementById("quiz.gcReminder.gcExpiryDate.day").focus();
            } else if (validator.isEmpty(this.state.gcExpYear)) {
                document.getElementById("quiz.gcReminder.gcExpiryDate.year").focus();
            } else {
                document.getElementById("quiz.gcReminder.gcExpiryDate.month").focus();
            }
        } else if (this.state.isResidenceSinceDateError) {
            if (validator.isEmpty(this.state.residenceSinceMonth)) {
                document.getElementById("quiz.gcReminder.residenceSinceDate.month").focus();
            } else if (validator.isEmpty(this.state.residenceSinceDay)) {
                document.getElementById("quiz.gcReminder.residenceSinceDate.day").focus();
            } else if (validator.isEmpty(this.state.residenceSinceYear)) {
                document.getElementById("quiz.gcReminder.residenceSinceDate.year").focus();
            } else {
                document.getElementById("quiz.gcReminder.residenceSinceDate.month").focus();
            }
        } else if (this.state.isResidenceSinceDateCompareError) {
            document.getElementById("quiz.gcReminder.residenceSinceDate.month").focus();
        } else if (this.state.isIagreeError) {
            document.getElementById("iagree").focus();
        }
    }

    render() {
        return (
            <div className="site-content">
                <div className="site-content-container">
                    <div className={this.state.existingCustomer ? "gc-expiration-reminder simple-form" : "gc-expiration-reminder"}>
                        <div className="gc-expiration-reminder-main">
                            <div className="gc-expiration-reminder-header">
                                <div className="gc-expiration-reminder-header-text">
                                    <h1>Green Card <span>Expiration Reminder Service</span></h1>
                                    <h2>Find out when to renew your green card and get notified</h2>
                                </div>
                                <div className="gc-expiration-reminder-header-image">
                                    <img alt="Green Card-Expiration Reminder Service"
                                         src="/assets-static/46a4e7b4504d43a0ea7dc32d86ef30a3980854a4/images/reminder-icon.png"
                                         title="Green Card-Expiration Reminder Service"/>
                                </div>
                            </div>

                            <div className="gc-expiration-reminder-content">
                                <form id="reminder" autoComplete="off" spellCheck="false" method="post"
                                      onSubmit={this.handleSubmit} action="/i90premium/controller.do">

                                    <div className="gc-expiration-reminder-image">
                                        <div className="heading">Where can I find the "Card Expires" and "Resident
                                            Since"?
                                        </div>
                                        <div className="gc-expiration-reminder-image-new">
                                            <div className="img">
                                                <p className="img-text">The Modern Green Card (2010 – present)</p>
                                                <a onClick={(e) => this.handleClick(e)}>
                                                    <img id="greenCard" alt="The Modern Green Card (2010 – present)"
                                                         src="/assets-static/46a4e7b4504d43a0ea7dc32d86ef30a3980854a4/images/expire-date-highlight-green-card.png"
                                                         title="The c (2010 – present)"/>
                                                </a>
                                            </div>
                                            <div className="link">
                                                <a id="greenCardLarge"
                                                   onClick={(e) => this.handleClick(e)}>Click to enlarge</a>
                                            </div>
                                        </div>
                                        <div className="gc-expiration-reminder-image-old">
                                            <div className="img">
                                                <p className="img-text">Permanent Resident Card (1997-2010)</p>
                                                <a onClick={(e) => this.handleClick(e)}>
                                                    <img id="prCard" alt="Permanent Resident Card (1997-2010)"
                                                         src="/assets-static/46a4e7b4504d43a0ea7dc32d86ef30a3980854a4/images/expire-date-highlight-permanent-resident-card.png"
                                                         title="Permanent Resident Card 1997-2010)"/>
                                                </a>
                                            </div>
                                            <div className="link">
                                                <a id="prCardLarge"
                                                   onClick={(e) => this.handleClick(e)}>Click to enlarge</a>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="gc-expiration-reminder-form">
                                        {!this.state.existingCustomer &&
                                        <div>
                                            <InputText
                                                className=""
                                                id="quiz.gcReminder.name.first"
                                                fieldLabel="First Name"
                                                name="quiz.gcReminder.name.first"
                                                type="text"
                                                value={this.state.firstName}
                                                maxlength="50"
                                                autoFocus={true}
                                                fieldError={this.state.isFirstNameError}
                                                fieldErrorMessage={this.state.firstNameErrorMessage}
                                                handleChange={this.handleChange}
                                            />
                                        </div>}

                                        {!this.state.existingCustomer &&
                                        <div>
                                            <InputText
                                                className=""
                                                id="quiz.gcReminder.name.last"
                                                fieldLabel="Last Name"
                                                name="quiz.gcReminder.name.last"
                                                type="text"
                                                value={this.state.lastName}
                                                maxlength="50"
                                                fieldError={this.state.isLastNameError}
                                                fieldErrorMessage={this.state.lastNameErrorMessage}
                                                handleChange={this.handleChange}
                                            />
                                        </div>}

                                        {!this.state.existingCustomer &&
                                        <div>
                                            <InputText
                                                className=""
                                                id="quiz.gcReminder.emailAddress"
                                                fieldLabel="E-Mail Address"
                                                name="quiz.gcReminder.emailAddress"
                                                type="text"
                                                value={this.state.emailAddress}
                                                maxlength="50"
                                                fieldError={this.state.isEmailAddressError}
                                                fieldErrorMessage={this.state.emailAddressErrorMessage}
                                                handleChange={this.handleChange}
                                            />
                                        </div>}

                                        <div>
                                            <InputDate
                                                monthId="quiz.gcReminder.gcExpiryDate.month"
                                                monthName="quiz.gcReminder.gcExpiryDate.month"
                                                dayId="quiz.gcReminder.gcExpiryDate.day"
                                                dayName="quiz.gcReminder.gcExpiryDate.day"
                                                yearId="quiz.gcReminder.gcExpiryDate.year"
                                                yearName="quiz.gcReminder.gcExpiryDate.year"
                                                dayValue={this.state.gcExpDay}
                                                monthValue={this.state.gcExpMonth}
                                                yearValue={this.state.gcExpYear}
                                                fieldLabel="Card Expires"
                                                fieldLabelSubText=" (as printed on your green card)"
                                                fieldError={this.state.isGCExpirationDateError}
                                                fieldErrorMessage={this.state.gcExpirationDateErrorMessage}
                                                handleChange={this.handleChange}
                                            />
                                        </div>

                                        <div>
                                            <InputDate
                                                monthId="quiz.gcReminder.residenceSinceDate.month"
                                                monthName="quiz.gcReminder.residenceSinceDate.month"
                                                dayId="quiz.gcReminder.residenceSinceDate.day"
                                                dayName="quiz.gcReminder.residenceSinceDate.day"
                                                yearId="quiz.gcReminder.residenceSinceDate.year"
                                                yearName="quiz.gcReminder.residenceSinceDate.year"
                                                dayValue={this.state.residenceSinceDay}
                                                monthValue={this.state.residenceSinceMonth}
                                                yearValue={this.state.residenceSinceYear}
                                                fieldLabel="Resident Since"
                                                fieldLabelSubText=" (as printed on your green card)"
                                                fieldError={this.state.isGCExpirationDateError || this.state.isResidenceSinceDateError ? this.state.isResidenceSinceDateError : this.state.isResidenceSinceDateCompareError}
                                                fieldErrorMessage={this.state.isGCExpirationDateError || this.state.isResidenceSinceDateError ? this.state.residenceSinceDateErrorMessage : this.state.residenceSinceDateCompareErrorMessage}
                                                handleChange={this.handleChange}
                                            />
                                        </div>

                                        <div>
                                            <input
                                                id="quiz.gcReminder.existingCustomer"
                                                name="quiz.gcReminder.existingCustomer"
                                                value={this.state.existingCustomer}
                                                type="hidden"
                                            />
                                        </div>

                                        {this.state.existingCustomer &&
                                        <div>
                                            <input
                                                id="quiz.gcReminder.emailAddress"
                                                name="quiz.gcReminder.emailAddress"
                                                value={this.state.emailAddress}
                                                type="hidden"
                                            />
                                        </div>}

                                        <div>
                                            <input
                                                id="eventType"
                                                name="eventType"
                                                value="gc"
                                                type="hidden"
                                            />
                                        </div>

                                        <div>
                                            <input
                                                id="quiz.gcReminder.gcExpiryDate"
                                                name="quiz.gcReminder.gcExpiryDate"
                                                value={this.state.gcExpiryDate}
                                                type="hidden"
                                            />
                                        </div>

                                        <div>
                                            <input
                                                id="quiz.gcReminder.eventDate"
                                                name="quiz.gcReminder.eventDate"
                                                value={this.state.eventDate}
                                                type="hidden"
                                            />
                                        </div>

                                        <div>
                                            <input
                                                id="quiz.gcReminder.residenceSinceDate"
                                                name="quiz.gcReminder.residenceSinceDate"
                                                value={this.state.residenceSinceDate}
                                                type="hidden"
                                            />
                                        </div>

                                        <div>
                                            <input
                                                id="interaction"
                                                name="interaction"
                                                value="eq"
                                                type="hidden"
                                            />
                                        </div>

                                        <div>
                                            <input
                                                id="page"
                                                name="page"
                                                value="/i90premium/EQ-3.3.jsp"
                                                type="hidden"
                                            />
                                        </div>

                                        <div>
                                            <input
                                                id="pageStatus"
                                                name="pageStatus"
                                                value="PAGE_STATUS_NOT_VISITED"
                                                type="hidden"
                                            />
                                        </div>

                                        <div>
                                            <input
                                                id="next"
                                                name="next"
                                                value="continue"
                                                type="hidden"
                                            />
                                        </div>

                                        <div className="field">
                                            <div className="checkbox element">
                                                <label>
                                                    <input id="iagree" name="iagree" type="checkbox"
                                                           onChange={(e) => this.handleChange(e)}/>
                                                    <span>
                                                        I agree to the <a
                                                        onClick={() => popupWindow('/terms-and-conditions.jsp', 800, 600)}>Terms of Use</a> and <a
                                                        onClick={() => popupWindow('/privacy-policy.jsp', 800, 600)}>
                                                        Privacy Policy</a>
                                                    </span>
                                                </label>
                                                {(this.state.isIagreeError && this.state.iagreeErrorMessage) &&
                                                <p id="name-error" className="error"><FormattedMessage
                                                    id={this.state.iagreeErrorMessage}/></p>
                                                }
                                            </div>
                                        </div>

                                        <div className="form-buttons">
                                            <button type="submit" id="submitCheckNow" name="submitCheckNow"
                                                    onClick={this.submitClick}>Check Now
                                            </button>
                                        </div>

                                    </div>
                                </form>

                                <div className="gc-expiration-reminder-notice">
                                    <div className="gc-expiration-reminder-notice-content">The Green Card Expiration
                                        Reminder Tool was created using instructions, rules and regulations published by
                                        the U.S. Citizenship and Immigration Service. The responses provided are
                                        automatically generated using the guidelines contained in USCIS materials. This
                                        tool should not be used as a substitute for the advice of an attorney. We do not
                                        guarantee the accuracy of results or that a reminder will be sent to or received
                                        by you. Our Reminder Tool is an additional resource to help you track dates that
                                        may be important to you and should not be exclusively relied upon to determine
                                        your individual immigration status or filing requirements.
                                    </div>
                                </div>

                            </div>
                            {this.state.togglePRCardLightbox &&
                            <PRCardLightbox handle={this.handleClick}/>}
                            {this.state.toggleGreenCardLightbox &&
                            <GreenCardLightbox handle={this.handleClick}/>}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Reminder;
